var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"clock",staticClass:"clock"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"hand",style:({transform: _vm.getHandTransform('hours')})}),_c('div',{staticClass:"hand",style:({transform: _vm.getHandTransform('minutes')})})])])
}
var staticRenderFns = []

export { render, staticRenderFns }